<template>
    <ModalWithButton
        :name="modalName"
        title="Crear nuevo precio"
        button_title="Crear nuevo precio"
        @cerrar="cerrar()"
    >
        <Form :data="data" @terminado="addPrice()"/>
    </ModalWithButton>
</template>

<script>
    import ModalWithButton from '@/components/backend/components/ModalWithButton.vue';
    import Form from '../Form.vue';

    export default {
        props: {
            pack_id: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                data: {
                    pack_id: this.pack_id,
                    pack_event_id: this.pack_id
                },
                modalName: 'add-price',
            }
        },
        created() {
        },
        methods: {
            addPrice() {
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.prices.create'), this.data).then(res => {
                    this.$emit('actualizar');
                    this.cerrar();
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.addPrice();
                }
            },
            cerrar() {
                this.$modal.hide(this.modalName);
                this.data = {
                    pack_id: this.pack_id
                };
            }
        },
        components: {
            ModalWithButton, Form
        }
    }
</script>
